"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// assets
//
const appsCopy_1 = require("../../../../copy/appsCopy");
const malomo_png_1 = __importDefault(require("../../../../assets/images/dashboard/apps/malomo.png"));
const shopify_png_1 = __importDefault(require("../../../../assets/images/dashboard/apps/shopify.png"));
const klaviyo_png_1 = __importDefault(require("../../../../assets/images/dashboard/apps/klaviyo.png"));
const postscript_png_1 = __importDefault(require("../../../../assets/images/dashboard/apps/postscript.png"));
const attentive_png_1 = __importDefault(require("../../../../assets/images/dashboard/apps/attentive.png"));
//
// styles
//
const StyledAppContainer_1 = require("./StyledAppContainer");
const StyledConnectedIcon_1 = require("./StyledConnectedIcon");
const StyledLogo_1 = require("./StyledLogo");
const StyledSectionText_1 = require("../../StyledSectionText");
const MalomoText_1 = require("../../MalomoText");
const MalomoButton_1 = require("../../MalomoButton");
const Flex_1 = require("../../Flex");
const StyledTextContainer_1 = require("./StyledTextContainer");
const logos = {
    shopify: shopify_png_1.default,
    klaviyo: klaviyo_png_1.default,
    postscript: postscript_png_1.default,
    attentive: attentive_png_1.default
};
const AppModule = (props) => {
    function logoSrc(name) {
        if (name in logos) {
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return logos[name];
        }
        return malomo_png_1.default;
    }
    function openLink(url) {
        window.open(url, '_blank');
    }
    return (react_1.default.createElement(StyledAppContainer_1.StyledAppContainer, null,
        react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
            react_1.default.createElement(StyledLogo_1.StyledLogo, { src: logoSrc(props.app.name.toLowerCase()) }),
            react_1.default.createElement(StyledTextContainer_1.StyledTextContainer, null,
                react_1.default.createElement(StyledSectionText_1.StyledSectionText, { className: 'app-name' }, props.app.name),
                react_1.default.createElement(MalomoText_1.MalomoText, { className: 'app-category', gray: true, paragraph: true, small: true }, props.app.category),
                props.app.installed && (react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
                    react_1.default.createElement(StyledConnectedIcon_1.StyledConnectedIcon, null),
                    react_1.default.createElement(MalomoText_1.MalomoText, { className: 'connected', paragraph: true, small: true }, appsCopy_1.appsCopy.appConnected))))),
        react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true }, props.app.installed ? (react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
            react_1.default.createElement(MalomoButton_1.MalomoButton, { className: 'uninstall-app', margin: '5px', onClick: () => props.uninstall(props.app.clientId), secondary: true }, appsCopy_1.appsCopy.uninstall),
            react_1.default.createElement(MalomoButton_1.MalomoButton, { className: 'reinstall-app', margin: '5px', onClick: () => openLink(props.app.installUrl) }, appsCopy_1.appsCopy.reinstall))) : (react_1.default.createElement(MalomoButton_1.MalomoButton, { className: 'install-app', margin: '5px', onClick: () => openLink(props.app.installUrl) }, appsCopy_1.appsCopy.install)))));
};
AppModule.propTypes = {
    app: prop_types_1.default.shape({
        category: prop_types_1.default.string,
        installUrl: prop_types_1.default.string,
        installed: prop_types_1.default.bool,
        name: prop_types_1.default.string,
        clientId: prop_types_1.default.string
    }),
    uninstall: prop_types_1.default.func
};
exports.default = AppModule;
